import { query } from "@solidjs/router";
import { runQueryCommand, RIASTABLE } from "~/_server/dynamoDB";
import {
	getByRowTypeServer,
	getByUserQueryServer,
	getProfileQueryServer,
	getProjectCertificatesServer,
	getUserCertificatesServer,
	getCognitoProfile,
	getUserSubscriptionsServer,
} from "~/_server/dynamoQueries";
import { SubscriptionState, RIASRecordType } from "~/lib/types";
import { DAY_IN_SECONDS } from "~/lib/constants";

export const getUserInfoQuery = query(getCognitoProfile, "userInfo");

export const getUserCertificates = query(
	getUserCertificatesServer,
	"getUserCertificates",
);

export const getUserSubscriptions = query(
	getUserSubscriptionsServer,
	"getUserSubscriptions",
);

export const getProjectCertificates = query(
	getProjectCertificatesServer,
	"getProjectCertificates",
);

export const getByUserQuery = query(getByUserQueryServer, "getByUser");

export const getByRowType = query(getByRowTypeServer, "getByRowType");

export const getProfileQuery = query( getProfileQueryServer, "profileInfo" );

export const getAssessments = query( async (id:number|undefined = undefined) => await getByUserQueryServer( RIASRecordType.ASSESSMENT, -1, undefined, id ).then( res => res.items.sort( ( a, b ) => a.created - b.created ) ?? [] ), "getUserAssessments" );

export const getMaxAttempts = query( async (id:number|undefined = undefined) => await getByUserQueryServer( RIASRecordType.MAX_ATTEMPTS, -1, undefined, id ).then( res => res?.items ?? [] ), "getUserMaxAttempts" );

//export const getByPKQuery = query(getByPKQueryServer, "queryByPK");

export const expiringSubs = query(async () => {
	"use server";

	const NOW = Math.floor(Date.now() / 1000);

	const r = await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiByExpires",

		KeyConditionExpression:
			"recordType = :rt AND expires BETWEEN :exp1 AND :exp2",
		ExpressionAttributeValues: {
			":rt": "SUBSCRIPTION",
			":exp1": NOW - 180 * DAY_IN_SECONDS,
			":exp2": NOW + 21 * DAY_IN_SECONDS,
		},
	});

	return r?.items.filter(s => s.status != SubscriptionState.TERMINATED) ?? [];
}, "expiringSubs");
